import { BUTTON_SIZES } from 'ui/button/constants';
import { ButtonGroup } from 'ui/buttonGroupV2/ButtonGroup';
import { AddNew16, DatabaseBlock16, Export16, SvgIconProps } from 'ui/icons';

export const DATA_TEST = {
  unsubscribeList: 'export-unsubscribed-list-button',
  unsubscribeUser: 'channel-unsubscribe-users-button',
  subscribeUser: 'channel-subscribe-users-button',
};

const buildOption = (id: string, Icon: React.FC<SvgIconProps>, text: string, url: string) => ({
  id,
  'data-test': id,
  children: (
    <>
      <Icon /> {text}
    </>
  ),
  onClick: () => {
    window.location.href = url;
  },
});

export const ListActionsToolbar = () => (
  <ButtonGroup
    options={[
      buildOption(
        DATA_TEST.unsubscribeList,
        Export16,
        'Export Unsubscribed List',
        '/lists/exportUnsubscribed',
      ),
      buildOption(
        DATA_TEST.unsubscribeUser,
        DatabaseBlock16,
        'Channel Unsubscribe Users',
        '/lists/channelUnsubscribe',
      ),
      buildOption(
        DATA_TEST.subscribeUser,
        AddNew16,
        'Channel Subscribe Users',
        '/lists/channelSubscribe',
      ),
    ]}
    size={BUTTON_SIZES.LARGE}
  />
);
